import { render, staticRenderFns } from "./TemplateFooterPage.vue?vue&type=template&id=37843f1a&"
import script from "./TemplateFooterPage.vue?vue&type=script&lang=js&"
export * from "./TemplateFooterPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports